import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';

import {Table, TableBody, TableCell, TableHead, TableRow}  from '@material-ui/core';
//Box, Grid, Button,
import {Paper, IconButton} from '@material-ui/core';
//, Menu, MenuItem, ListItemIcon, ListItemText
import {Checkbox } from '@material-ui/core';
//import {TextField, Select} from '@material-ui/core';
//import MoreVert from '@material-ui/icons/MoreVert';
//import EditIcon from '@material-ui/icons/Edit';
//import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
//import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { getIndexByID } from '../../../api/helpers';
//import { sortByLogin } from '../../../api/helpers';

import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';

class DispatchersListEditor_ extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            menuAnchor: null,
            dispatcherFilter: '',
            selectedID: null
        }
    }

    handleDispatcherSelect(dispatcherID, state){
        this.props.onSelect(dispatcherID)
    }

    isSelected(dispatcherID, state){
        let selected = dispatcherID === this.props.selectedID
        return selected
    }

    getRowStyle(dispatcherID, state){
        let style = {
            background: this.isSelected(dispatcherID) ? theme.palette.background.selectedRow : '',
            cursor: 'pointer'
        }
        return style
    }

    handleChange(name, id, value){
        if(name==='AllGroups'){
            this.props.onAction({type:'SET_DISPATCHER_ALL_GROUPS', id: id,  value: value})
        }
    }

    render(){

        //console.log('render DispatchersListEditor')
        //console.log(this.props)

        const {t} = this.props

        let dispatchers = [];
        if(this.props.dispatchers){
            dispatchers = this.props.dispatchers
        }else{
            return '';
        }
        //console.log('render this.props.dispatchers')
        //console.log(this.props.dispatchers)


        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            },
        };

        return(
            <>
                <Paper style={styles.paper}>

                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell style={{...styles.head, width:30}}></TableCell>
                                <TableCell style={styles.head}>{t('Name')}</TableCell>
                                <TableCell align='center' style={styles.head}>{t('AllGroups')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {dispatchers.map((dispatcher) => 
                            <TableRow key={dispatcher.ID} 
                                    onClick={()=>{this.handleDispatcherSelect(dispatcher.ID)}}
                                    style={this.getRowStyle(dispatcher.ID, this.state)}>
                                <TableCell>
                                    <SupervisorAccountIcon color={this.isSelected(dispatcher.ID, this.state)?"primary":"inherit"} />
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {dispatcher.Name}
                                </TableCell>
                                <TableCell align='center' component="th" scope="row">
                                    <Checkbox 
                                        color="primary" 
                                        checked={dispatcher.AllGroups}
                                        style={{width: 30, height: 30, marginRight: '0.5em'}}
                                        disabled={dispatcher.AllGroups===null}
                                        onChange={event=>{
                                            this.handleChange('AllGroups', dispatcher.ID, event.target.checked)
                                        }}
                                        ></Checkbox>
                                </TableCell>
                            </TableRow>
                        )}
                        </TableBody>
                    </Table>
                </Paper>
            </>
        )

    }

}

export const DispatchersListEditor = withTranslation()(DispatchersListEditor_);